var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionGr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 15,
    viewBox: "0 0 35 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.446 8.27268L33.3213 3.53008L28.1851 0.999507",
    stroke: "#46C62F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5905 4.99596C32.1406 4.94596 32.5459 4.45955 32.4959 3.90953C32.4459 3.35951 31.9595 2.95417 31.4095 3.00417C28.4245 3.27553 26.0417 4.50442 24.4153 6.48114C23.6182 7.44996 23.0198 8.57731 22.6181 9.8236C21.3421 8.10999 19.3007 7.00006 17 7.00006C14.3075 7.00006 11.97 8.52027 10.799 10.7492C9.88202 9.67854 8.52024 9.00006 7 9.00006C4.23858 9.00006 2 11.2386 2 14.0001H4C4 12.3432 5.34315 11.0001 7 11.0001C8.65685 11.0001 10 12.3432 10 14.0001H12C12 11.2386 14.2386 9.00006 17 9.00006C19.7614 9.00006 22 11.2386 22 14.0001H24C24 11.4153 24.7011 9.28163 25.9597 7.75185C27.2083 6.23429 29.0755 5.2246 31.5905 4.99596Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 14.5C0.5 14.2239 0.723858 14 1 14H5C5.27614 14 5.5 14.2239 5.5 14.5C5.5 14.7761 5.27614 15 5 15H1C0.723858 15 0.5 14.7761 0.5 14.5Z",
    fill: "url(#paint1_linear_1_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.5C7.5 14.2239 7.72386 14 8 14H14C14.2761 14 14.5 14.2239 14.5 14.5C14.5 14.7761 14.2761 15 14 15H8C7.72386 15 7.5 14.7761 7.5 14.5Z",
    fill: "url(#paint2_linear_1_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 14.5C19.5 14.2239 19.7239 14 20 14H26C26.2761 14 26.5 14.2239 26.5 14.5C26.5 14.7761 26.2761 15 26 15H20C19.7239 15 19.5 14.7761 19.5 14.5Z",
    fill: "url(#paint3_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 32.0081,
    y1: 3,
    x2: -6.96837,
    y2: 15.1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39C023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86F260",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 0.777778,
    y1: 14.5,
    x2: 3.81499,
    y2: 12.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FC68",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#C6FCBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE235",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 7.66667,
    y1: 14.5,
    x2: 10.9307,
    y2: 11.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFC68",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#B4FAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38E235",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 19.6667,
    y1: 14.5,
    x2: 22.9307,
    y2: 11.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DFC68",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#80F876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE235",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionGr);
export default __webpack_public_path__ + "static/media/union-gr.0a4f7722a19a28d98618c0c5f5dd98ff.svg";
export { ForwardRef as ReactComponent };